import { gql } from 'apollo-angular'

export const PURCHASE_ARTICLE = gql`
  mutation purchaseArticle(
    $articleId: Int!
    $customer: PurchaseArticleCustomerInput!
    $options: PurchaseArticleOptionsInput
  ) {
    purchaseArticle(
      data: { articleId: $articleId, customer: $customer, options: $options }
    ) {
      checkoutUrl
      purchaseId
    }
  }
`
